import { InteractiveContainer } from "@jugl-web/ui-kit";
import { FC } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import animationIconData from "./assets/animation-icon.json";
import { ReactComponent as AddIcon } from "./assets/add-icon.svg";

export const CreateNewEntityButton: FC<{
  onCreateClick?: () => void;
}> = ({ onCreateClick }) => {
  const { navigateToPage } = useNavigation();
  const { t } = useTranslations();

  const handleAddOrganizationClick = async () => {
    if (onCreateClick) {
      onCreateClick();
      return;
    }
    navigateToPage("authNewWorkspace", {
      flow: "inapp",
    });
  };

  return (
    <InteractiveContainer
      className="flex h-[73px] items-center overflow-hidden rounded-2xl"
      onClick={handleAddOrganizationClick}
      as="div"
      style={{
        background: "linear-gradient(270deg, #DAEFFB 0.03%, #F6F3FF 99.98%)",
      }}
    >
      <div className="relative -top-[8px]">
        <Lottie
          options={{ animationData: animationIconData }}
          width={84}
          height={84}
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-secondary text-sm leading-4 font-medium text-dark">
          {t({
            id: "entities-page.create-new-workspace",
            defaultMessage: "Create New Workspace",
          })}
        </div>
        <div className="font-primary text-xs leading-2 text-[#707577]">
          {t({
            id: "entities-page.tap-to-create",
            defaultMessage: "Tap to create",
          })}
        </div>
      </div>
      <div className="mr-[18px] flex h-[28px] w-[28px] items-center justify-center rounded-[6px] bg-primary-500">
        <AddIcon />
      </div>
    </InteractiveContainer>
  );
};
